<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">Türkiye Buz Pateni Federasyonu</a>
      <button type="button" class="navbar-toggler navbar-toggler-right" v-bind:class="{toggled: $sidebar.showSidebar}" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto">
          
        </ul>
        <ul class="navbar-nav ml-auto">
          
          <drop-down tag="li">
            <template slot="title">
              <i class="nc-icon nc-circle-09"></i>
              <b class="caret"></b>
            </template>
            <a class="dropdown-item" :href="'/#/user/add-edit/' + getCurrentUserDetails().id">Profilim</a>
          </drop-down>
          <li class="nav-item">
            <a href="https://www.buzpateni.org.tr/" target="_blank" class="nav-link">
              Siteyi Gör
            </a>
          </li>
          <li class="nav-item">
            <a href="javascript:void(0)" v-on:click="logout" class="nav-link">
              <i class="fas fa-sign-out-alt"></i> <span style="height: 100%">Çıkış</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      logout: function(){
        this.toggleLoader()
        this.$http.get('/api/users/logout', this.credentials).then(
          response => {
            localStorage.removeItem('CurrentLoggedUserDetails');
            this.$router.push('/main')
            location.reload()
          },
          e => {
            this.$router.push('/main')
            location.reload()
          })
      }
    }
  }

</script>
<style>

.btn-search{
  margin: 0 !important;
  border-width: 1px;
  border-left-style: none;
}
.input-search{
  border-color: #888888;
  border-right-style: none;
}
.navbar .navbar-nav .nav-item .nav-link [class^="fa"]{
  line-height: 1.2;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue